export const ADD_BOX_REQUEST = 'ADD_BOX_REQUEST'
export const ADD_BOX_SUCCESS = 'ADD_BOX_SUCCESS'
export const ADD_BOX_FAIL = 'ADD_BOX_FAIL'

export const TABLE_DROPDOWN_OPEN = 'TABLE_DROPDOWN_OPEN'
export const TABLE_DROPDOWN_CLOSE = 'TABLE_DROPDOWN_CLOSE'

export const SELECT_DROPDOWN_OPEN = 'SELECT_DROPDOWN_OPEN'
export const SELECT_DROPDOWN_CLOSE = 'SELECT_DROPDOWN_CLOSE'

export const SELECTED_TAB_SUCCESS = 'SELECTED_TAB_SUCCESS'
export const SELECTED_ORDER_TYPE_SUCCESS = 'SELECTED_TAB_SUCCESS'

export const SELECTED_ATTACHMENT_INFO_OPEN = 'SELECTED_ATTACHMENT_INFO_OPEN'
export const SELECTED_ATTACHMENT_INFO_CLOSE = 'SELECTED_ATTACHMENT_INFO_CLOSE'

export const SELECTED_DATE_SUCCESS = 'SELECTED_DATE_SUCCESS'

export const LOADING_STATE_COUNTRY_DATA = 'LOADING_STATE_COUNTRY_DATA'
export const SUCCESS_STATE_COUNTRY_DATA = 'SUCCESS_STATE_COUNTRY_DATA'
export const FAILED_STATE_COUNTRY_DATA = 'FAILED_STATE_COUNTRY_DATA'

export const REQUEST_UI_RULES = 'REQUEST_UI_RULES'
export const SUCCESS_UI_RULES = 'SUCCESS_UI_RULES'
export const FAILED_UI_RULES = 'FAILED_UI_RULES'

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'

export const TOGGLE_WIDGET = 'TOGGLE_WIDGET'
export const SET_WIDGETS = 'SET_WIDGETS'

// Pending Quote Attachment Management
export const SET_PENDING_QUOTE_ATTACHMENT = 'SET_PENDING_QUOTE_ATTACHMENT'
export const CLEAR_PENDING_QUOTE_ATTACHMENT = 'CLEAR_PENDING_QUOTE_ATTACHMENT'
export const GET_PENDING_QUOTE_ATTACHMENT = 'GET_PENDING_QUOTE_ATTACHMENT'

// File Type
export const GET_FILE_TYPE = 'GET_FILE_TYPE'
export const SET_FILE_TYPE = 'SET_FILE_TYPE'
export const CLEAR_FILE_TYPE = 'CLEAR_FILE_TYPE'
